export { default as StartStep } from './StartStep';
export { default as ContainerForm } from './ContainerForm';
export { default as FormBankCardDetails } from './FormBankCardDetails';
export { default as FormPhoneNumber } from './FormPhoneNumber';
export { default as FormConfirmationCode } from './FormConfirmationCode';
export { default as FormAccess } from './FormAccess';
export { default as LastStep } from './LastStep';
